import React from "react";
import { motion } from "framer-motion";
import { connect } from 'react-redux';
import User from "./components/Admin/user";
import Logs from "./components/Admin/logs";
import { changeActiveTab } from "../redux/actions/admin.action";

const Admin = (props) => {
    if (props.staff !== 1337) return (
        <div className="content">
            <div className="c-white text-center">Page not authorized</div>
        </div>
    );
    return (
        <>
            <div className="content">
                <div className="adminTool-btns">
                    <motion.div
                        className={`adminTool-btn ${props?.adminTab === "userManagement" ? 'isActive' : ''}`}
                        whileTap={{ scale: 0.97}}
                        onClick={(e) => props.changeActiveTab("userManagement")}
                    >
                        User management
                    </motion.div>
                    <motion.div 
                        className={`adminTool-btn ${props?.adminTab === "logs" ? 'isActive' : ''}`} 
                        whileTap={{ scale: 0.97}}
                        onClick={(e) => props.changeActiveTab("logs")}
                    >
                        Logs
                    </motion.div>
                    <motion.div 
                        className={`adminTool-btn ${props?.adminTab === "stats" ? 'isActive' : ''}`}
                        whileTap={{ scale: 0.97}}
                        onClick={(e) => props.changeActiveTab("stats")}
                    >
                        Stats
                    </motion.div>
                </div>
                {props?.adminTab === "userManagement" && <User/>}
                {props?.adminTab === "logs" && <Logs/>}
            </div>
        </>
    );
};

const mapDispatchToProps = {
    changeActiveTab
};

const mapStateToProps = (state) => {
    const { adminTab } = state.admin;
    const { staff } = state.infos;
    return { adminTab, staff };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);